import { StatusBar, Style } from '@capacitor/status-bar'

import { platform } from './platform'

export async function applyStatusBar(theme: 'dark' | 'light' = 'dark') {
  if (!platform.isNative()) return
  await StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light })
  if (platform.isAndroid()) {
    await StatusBar.setBackgroundColor({ color: theme === 'dark' ? '#0b0b10' : '#ffffff' })
  }
}
